export default "__VITE_ASSET__3cbc3480__"